import classNames from 'classnames';
import React, { ReactNode } from 'react';
import styles from './Toolbar.module.scss';

export function Toolbar(props: {
    leftContent?: ReactNode;
    rightContent?: ReactNode;
    fullPadding?: boolean;
    children?: ReactNode;
}) {
    return (
        <div className={classNames(styles.toolbar, { [styles.fullPadding]: props.fullPadding })}>
            {props.leftContent && <div className={styles.leftContent}>{props.leftContent}</div>}
            {props.children && <div className={styles.otherContent}>{props.children}</div>}
            {props.rightContent && <div className={styles.rightContent}>{props.rightContent}</div>}
        </div>
    );
}

export const ToolbarDivider = () => {
    return <div className={styles.divider} />;
};
